import { render } from "./Topics.vue?vue&type=template&id=b610c2f0"
import script from "./Topics.vue?vue&type=script&lang=ts"
export * from "./Topics.vue?vue&type=script&lang=ts"

import "./Topics.vue?vue&type=style&index=0&id=b610c2f0&lang=scss"
script.render = render

export default script